export default __webpack_public_path__ + "static/media/market_cap.c905f0fc.png";